module.exports = __webpack_public_path__ + "media/images/flags/ps-11612d785462813fa6c37a4508c6fb5b.svg";